import React, { useState } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Card,
  CardContent,
  CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";
import { postRequest, server } from "../config";

const SendNotificationPage = () => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  // 📤 Upload Image to /images/upload
  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64String = reader.result.split(",")[1];
        const payload = {
          fileName: `notification_${Date.now()}`,
          fileType: file.type.split("/")[1],
          fileData: base64String,
        };

        const response = await postRequest(`${server.uri}images/upload`, payload);
        if (response?.fileUrl || response?.url) {
          const finalUrl = response.fileUrl
            ? `${response.fileUrl}`
            : `${response.url}`;
          setImageUrl(finalUrl);
          toast.success("Image uploaded successfully!");
        } else {
          toast.error("Failed to upload image");
        }
      };
      reader.readAsDataURL(file);
    } catch (error) {
      console.error("Image upload error:", error);
      toast.error("Error uploading image");
    } finally {
      setUploading(false);
    }
  };

  // 🚀 Send Notification to all users
  const handleSendNotification = async () => {
    if (!title || !body) {
      toast.error("Title and body are required");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        title,
        body,
        imageUrl,
        data: {},
        filter:{}
      };

      const response = await postRequest(
        `${server.uri}send-notifications-to-users`,
        payload
      );

      if (response?.success || response?.status === 200) {
        toast.success("Notification sent successfully!");
        setTitle("");
        setBody("");
        setImageUrl("");
      } else {
        toast.error("Failed to send notification");
      }
    } catch (error) {
      console.error("Send notification error:", error);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 6, mb: 6 }}>
      <Card elevation={3}>
        <CardContent>
          <Typography variant="h5" gutterBottom fontWeight={600}>
            Send Notification to All Users
          </Typography>

          <Box mt={3}>
            <TextField
              fullWidth
              label="Notification Title"
              variant="outlined"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              sx={{ mb: 2 }}
            />

            <TextField
              fullWidth
              multiline
              minRows={3}
              label="Notification Body"
              variant="outlined"
              value={body}
              onChange={(e) => setBody(e.target.value)}
              sx={{ mb: 2 }}
            />

            {/* Upload Image */}
            <Box sx={{ mb: 2 }}>
              <Button
                variant="contained"
                component="label"
                disabled={uploading}
              >
                {uploading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Upload Image"
                )}
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleImageUpload}
                />
              </Button>
            </Box>

            {/* Image Preview */}
            {imageUrl && (
              <Box
                sx={{
                  textAlign: "center",
                  mt: 2,
                  mb: 2,
                }}
              >
                <img
                  src={imageUrl}
                  alt="Uploaded"
                  style={{
                    width: 200,
                    borderRadius: 8,
                    boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
                  }}
                />
              </Box>
            )}

            {/* Send Button */}
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleSendNotification}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Send Notification"
              )}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default SendNotificationPage;
